import { Vector2 } from 'three'
import App from './App'

export class PointerControls {
	public readonly pointer: Vector2 = new Vector2()
	private app: App

	constructor(app: App) {
		this.onPointerMove = this.onPointerMove.bind(this)
		this.app = app
		document.body.addEventListener('pointermove', this.onPointerMove)
	}

	onPointerMove(event: PointerEvent): void {
		this.pointer.set((event.x / this.app.sizes.width) * 2 - 1, -(event.y / this.app.sizes.height) * 2 + 1)
		this.app.requestRender()
	}

	dispose(): void {
		document.body.removeEventListener('pointermove', this.onPointerMove)
	}
}
